import silentAudioUrl from './sound/silent.mp3';

let audio;
let unlocked = false;
let unlockPromise = null;
let playToken = 0;
let endedListener = null;

function getAudioPlayer() {
  if (audio === undefined) {
    audio = new Audio();
  }

  return audio;
}

function removeEndedListener() {
  if (audio !== undefined && endedListener !== null) {
    audio.removeEventListener('ended', endedListener);
  }

  endedListener = null;
}

function stopAudio() {
  playToken += 1;
  removeEndedListener();

  if (audio === undefined) {
    return;
  }

  audio.pause();
  audio.currentTime = 0;
}

function unlockAudio({ audioUrl = silentAudioUrl } = {}) {
  if (unlocked) {
    return Promise.resolve();
  }

  if (unlockPromise !== null) {
    return unlockPromise;
  }

  const audioPlayer = getAudioPlayer();
  playToken += 1;
  removeEndedListener();
  audioPlayer.src = audioUrl;
  audioPlayer.currentTime = 0;

  unlockPromise = audioPlayer.play()
  .then(() => {
    audioPlayer.pause();
    audioPlayer.currentTime = 0;
    unlocked = true;
  })
  .catch((error) => {
    unlocked = false;
    console.error('Audio unlock failed:', error);
  })
  .finally(() => {
    unlockPromise = null;
  });

  return unlockPromise;
}

function ensureUnlockAudio({ audioUrl = silentAudioUrl } = {}) {
  if (unlocked) {
    return Promise.resolve();
  }

  return unlockAudio({ audioUrl });
}

function playAudioSequence({ audioUrls }) {
  const playableAudioUrls = audioUrls.filter((audioSource) => audioSource !== undefined);
  if (playableAudioUrls.length === 0) {
    return;
  }

  const audioPlayer = getAudioPlayer();
  playToken += 1;
  const currentPlayToken = playToken;
  let index = 0;

  removeEndedListener();

  const playNext = () => {
    if (currentPlayToken !== playToken || index >= playableAudioUrls.length) {
      return;
    }

    audioPlayer.src = playableAudioUrls[index];
    audioPlayer.currentTime = 0;
    index += 1;

    audioPlayer.play()
    .then(() => {
      unlocked = true;
    })
    .catch((error) => {
      unlocked = false;
      console.error('Audio play failed:', error);
    });
  };

  endedListener = playNext;
  audioPlayer.addEventListener('ended', endedListener);
  playNext();
}

export {
  ensureUnlockAudio,
  getAudioPlayer,
  playAudioSequence,
  stopAudio,
  unlockAudio,
};
